import { CancelToken } from 'axios'
import apiInstance from '../../backend-api.setup'
import { ApiPathConfig } from '../../../config/ApiPathConfig'

const getBookRecoV3Service = (
  params: {
    eanIds: number[]
    nbrecos?: number
    popular_catalog_clil_name_filter?: string | null
  },
  cancelToken?: CancelToken,
): Promise<any> =>
  apiInstance.get(ApiPathConfig.BOOK_RECO_V3_WITH_EANS(params), { cancelToken })

export default getBookRecoV3Service
